import {gsap} from "gsap";
import Compare from "../Compare/Compare";
import Cookie from "@templates/App/Cookies.js";

const WishCompare = {
    saveButtons: [],
    storages: ["wishlist", "compare"],
    maxCompare: null,

    init() {
        this.saveButtons = $('[save-car]');
        this.compareList = $('[page="compare"]');
        this.wishList = $('[page="wishlist"]');
        this.control = $('[component="WishCompareControl"], [component="QuickFilter"] .links');
        this.compareTextAdd = window.T.STL.compare_add;
        this.compareTextRemove = window.T.STL.compare_remove;
        this.favouriteTextAdd = window.T.STL.wishlist_add;
        this.favouriteTextRemove = window.T.STL.wishlist_remove;

        this.bind();
        this.checkSaved();
        this.checkCompare();
    },

    bind() {
        this.saveButtons.click((evt) => {
            evt.stopPropagation();
            this.save($(evt.currentTarget));
            return false;
        });

        this.compareList.find('[save-car="compare"]').click((evt) => {
            this.remove($(evt.currentTarget));
        });

        this.wishList.find('[save-car="wishlist"]').click((evt) => {
            this.remove($(evt.currentTarget));
        });

        this.storages.forEach((el, i) => {
            this.control.find('[car-list="' + el + '"]').attr('title', window.T.STL[el]);
        })

    },

    get(storage) {
        let values = Cookie.get(storage + "New");

        if (values === undefined || values ==='') {
            return [];
        }
        return JSON.parse(values);
    },

    checkSaved() {
        for (let i = 0; i < this.storages.length; i++) {
            const storage = this.storages[i];
            const saved = this.get(storage);
            // console.log("Saved", storage, saved);

            this.updateCounts(storage, saved.length);
            const text = (storage === 'wishlist') ? this.favouriteTextRemove : this.compareTextRemove;

            for (let j = 0; j < saved.length; j++) {
                $('[save-car="' + storage + '"][car-id="' + saved[j] + '"]')
                    .attr('saved', 'true')
                    .attr('title', text)
                    .find('.name').text(text);
            }
        }
    },

    updateCounts(storage, count, button = null, animate = false) {
        const el = this.control.find('[car-list="' + storage + '"]');

        if (!animate) {
            el.find('.nmb b').text(count);
            return;
        }

        this.animateCounts(el, count, button);
    },

    animateCounts(el, count, button) {
        const img = el.find('img');
        const inner = el.find('.inner');
        const circle = el.find('.nmb');
        const nmb = circle.find('b');
        const copy = button.clone(false, false).addClass('copy').insertAfter(el);
        const scrollY = $('body, html').scrollTop();

        gsap.timeline({})
            .fromTo(copy, {x: button.offset().left}, {x: el.offset().left, ease: 'sine.in'}, 0)
            .fromTo(copy, {y: button.offset().top - scrollY}, {
                y: el.position().top, ease: 'sine.out', onComplete: () => {
                    copy.remove();
                }
            }, 0)
        const update = function () {
            nmb.text(count);
        }

        gsap.timeline({delay: 0.4})
            .to(inner, {scale: 1.6, ease: 'power4.out', duration: 0.7}, 0)
            .to(circle, {scale: 1.7, y: '10%', ease: 'power4.out', duration: 0.8}, 0)
            .add(update, 0.7)
            .to(circle, {scale: 1, y: '0%', ease: 'power4.in', duration: 0.3}, 1.2)
            .to(inner, {scale: 1, ease: 'power4.in', duration: 0.3}, 1.2)

        gsap.timeline({delay: 0.4})
            .fromTo(img, {x: -1}, {x: 1, duration: 0.1, clearProps: "x", repeat: 12})
    },

    checkCompare() {
        const compare = this.get('compare');
        if (!this.maxCompare) return;

        // if compare with maximum items () disable compare buttons
        if (compare.length >= this.maxCompare) {
            $('[save-car="compare"]:not([saved="true"])').attr('disabled', true);
        } else {
            $('[save-car="compare"][disabled]').removeAttr('disabled');
        }

    },

    save(el) {
        const carId = el.attr("car-id");
        const storage = el.attr("save-car");

        // if compare button disabled
        if (el.attr('disabled')) {
            console.log('disabled');
            return false;
        }

        if (!carId) {
            console.error("No car ID to save");
            return;
        }

        let values = this.get(storage);
        // console.log('save()',values)

        if (el.is('[saved]')) {
            const index = values.indexOf(carId);
            values.splice(index, 1);

            const text = (storage === 'wishlist') ? this.favouriteTextAdd : this.compareTextAdd;

            el.removeAttr('saved').attr('title', text).find('.name').text(text);
            this.updateCounts(storage, values.length, el, true);
        } else {
            values.push(carId);

            const text = (storage === 'wishlist') ? this.favouriteTextRemove : this.compareTextRemove;

            el.attr('saved', 'true').attr('title', text).find('.name').text(text);
            this.updateCounts(storage, values.length, el, true);
        }

        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        Cookie.set(storage + "New", JSON.stringify(values), expires);

        // check if maximum cars (4) in compare -> then redirect to compare
        /*
        if(storage === 'compare' && values.length >= 4) {
            window.location.replace('/ponuka/porovnanie');
        }
        */

        this.checkCompare();
    },

    remove(el) {
        const car = el.attr('save-car') === 'compare' ? el.closest('.owl-item') : el.closest('.car');

        gsap.to(car, {
            width: 0, height: 0, scale: 0, padding: 0, overflow: 'hidden', ease: 'power2.in', onComplete: () => {
                setTimeout(() => {
                    car.remove();
                    if (
                        this.get('compare').length === 0 && el.attr('save-car') === 'compare'
                        || this.get('wishlist').length === 0 && el.attr('save-car') === 'wishlist'
                    ) {
                        location.reload();
                    }
                    Compare.slider.trigger('destroy.owl.carousel');
                    setTimeout(() => {
                        Compare.initSlider();
                    }, 30)
                }, 100)
            }
        })
    }
}

export default WishCompare;